import { makeStyles } from '@mui/styles';

const SEARCH_DRAWER_WIDTH = 450;
const SEARCH_DRAWER_WIDTH_DESKTOP = 600;

export const useSearchDrawerStyles = makeStyles((theme) => ({
  // Note: the drawer's z-index is set via ModalProps inline style in the component (to beat the
  // class-based 1300 default reliably), not here.
  drawer: {
    width: SEARCH_DRAWER_WIDTH,
    flexShrink: 0,
    [theme.breakpoints.up('md')]: {
      width: SEARCH_DRAWER_WIDTH_DESKTOP
    }
  },
  drawerPaper: {
    width: SEARCH_DRAWER_WIDTH,
    maxWidth: '100vw',
    paddingTop: '8px',
    [theme.breakpoints.up('md')]: {
      width: SEARCH_DRAWER_WIDTH_DESKTOP
    }
  }
}));
